export const teamArchive = () => {
  const teamCard = document.querySelectorAll('.team-archive__team-card');

  teamCard.forEach((card) => {
    const regionLink = card.querySelector('.team-card__region-name');

    if (regionLink) {
      const regionModal = card.querySelector('.team-card__region-content');
      const regionClose = regionModal.querySelector('.modal__close-icon');
      regionLink.addEventListener('click', () => {
        regionModal.removeAttribute('hidden');
      });

      regionClose.addEventListener('click', () => {
        regionModal.setAttribute('hidden', true);
      });

      if (regionModal) {
        document.addEventListener('keydown', (e) => {
          if (e.code === 'Escape') {
            regionModal.setAttribute('hidden', true);
          }
        });
      }
    }
  });
};
